export const TRANSACTIONS_EVENTS = {
  TRNX_PAGE_VIEWED: "Transactions Viewed",
  FILTER_APPLIED: "Transactions Filter Applied",
  SEARCH_SUBMITTED: "Transactions Search Submitted",
  TRNX_ROW_OPENED: "Transaction Row Opened",
  TRNX_DETAILS_PAGE_VIEWED: "Transaction Details Viewed",
  TRNX_ACTION_CLICKED: "Transaction Action Clicked",
  TRNX_ACTION_CONFIRMED: "Transaction Action Confirmed",
  FINGERPRINT_CLICKED: "Fingerprint Clicked",
  FINGERPRINT_DEAD_CLICKS: "Fingerprint Dead Clicks",
  FINGERPRINT_PAYMENTS_VIEWED: "Fingerprint Payments Viewed",
  TRNX_TYPE_SELECTED: "Transaction Type Selected",
};

export const TRANSACTIONS_EVENTS_PARAMS = {
  DEFAULT_STATUS_FILTER: "default_status_filter",
  SEARCH_TYPE: "search_type",
  SEARCH_QUERY: "search_query",
  DATE_RANGE: "date_range",
  RESULTS_COUNT: "results_count",
  TRNX_ID: "transaction_id",
  TRNX_TYPE: "type",
  IS_TOKENIZED: "is_tokenized",
  ORDER_ID: "order_id",
  TRNX_STATUS: "status",
  PAYMENT_METHOD: "payment_method",
  ACTION: "action",
  STATUS_BEFORE: "status_before",
  CONFIRMATION_METHOD: "confirmation_method",
  FINGERPRINT: "fingerprint",
  TAB_NAME: "tab_name",
  CLICK_COUNTER: "click_counter"
};

export const TRANSACTIONS_EVENTS_VALUES = {
  FILTERS: {
    ALL: "All"
  },
  CONFIRMATION_METHOD: {
    MODAL: "modal"
  }
};